export default class InternalStakeholderDefinition {
    constructor(id) {
        this._id = id;
    }

    get id() {
        return this._id;
    }

    toObject() {
        return {
            id: this._id
        };
    }

    fromObject(obj) {
        this._id = obj.id;
    }
}